import script from "./MainFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./MainFooter.vue?vue&type=script&setup=true&lang=js"

import "./MainFooter.vue?vue&type=style&index=0&id=1686fa98&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/inticons/inticons/docs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1686fa98"]])

export default __exports__